import { render } from "./inputMail.vue?vue&type=template&id=36cf14a4&ts=true"
import script from "./inputMail.vue?vue&type=script&lang=ts"
export * from "./inputMail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__